var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4133 9.43007L12.4994 5.13264C12.274 4.93544 11.9333 4.96133 11.7393 5.18899C11.5444 5.41716 11.5693 5.76157 11.7947 5.9588L15.5612 9.25238H2.13914C1.84154 9.25238 1.6001 9.49654 1.6001 9.79806C1.6001 10.0996 1.84154 10.3437 2.13914 10.3437H15.6966L13.5498 12.2835L11.8727 13.6261C11.6395 13.8132 11.5994 14.1563 11.7842 14.3929C11.8905 14.5289 12.0485 14.6 12.2077 14.6C12.3248 14.6 12.4428 14.5617 12.5419 14.4822L14.243 13.1186L17.4196 10.2498C17.5354 10.1455 17.6011 9.99553 17.6001 9.83843C17.5986 9.68133 17.5311 9.5326 17.4133 9.43006L17.4133 9.43007Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5bd2299f108b481c40a40e15e89a6664.svg";
export { ForwardRef as ReactComponent };